
export default function ContactHero() {
  return (
    <section className="pt-32 pb-16 px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="font-sora font-bold text-5xl md:text-6xl text-charcoal mb-6 leading-tight">
          Book a Free 20-Minute Website Strategy Call
        </h1>
        <p className="font-inter text-lg md:text-xl text-gray-600 mb-3 leading-relaxed max-w-3xl mx-auto">
          Tell me a bit about your business and what you're looking for. If it's a fit, I'll respond within 24 hours with next steps.
        </p>
        <p className="font-inter text-sm text-gray-500">
          Projects typically start at $1,500.
        </p>
      </div>
    </section>
  );
}
